import classNames from 'classnames';
import { FunctionComponent } from 'react';

interface BSkeletonProps {
  className?: string;
}

const BSkeleton: FunctionComponent<BSkeletonProps> = ({ className }) => {
  return (
    <>
      <div className={classNames('skeleton', className)} />
      <style jsx>{`
        .skeleton {
          display: flex;
          position: relative;
          overflow: hidden;
          background-color: var(--clr-gray-100);
          border-radius: 6px;
        }
        .skeleton::after {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          transform: translateX(-100%);
          background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
          );
          animation: shimmer 2s infinite;
          content: '';
        }

        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </>
  );
};

export default BSkeleton;
